module.exports = "https://static.weeecdn.net/mweb/_next/static/images/landing-bg-887a58f7d6e22abf9eba8ccce5fec493.png";